'use client';
import { usePathname } from 'next/navigation';

import { useBlogPostBySlugQuery } from '../gql/__generated/blogPost.generated';
import { useRelatedProductsQuery } from '../gql/__generated/relatedProduct.generated';
import { BlogProduct } from '../model/blog-product.interface';
import { BlogRecommendationProducts } from './BlogRecommendationProducts';

interface RelatedProductsProps {
  entryId?: string | null;
}

export function RelatedProducts({ entryId }: RelatedProductsProps) {
  const pathname = usePathname();
  const slug = pathname.split('/').pop() || '';
  const { data: blogData } = useBlogPostBySlugQuery(
    {
      slug: slug || '',
    },
    {
      enabled: !!slug,
    }
  );

  const { data, isLoading } = useRelatedProductsQuery(
    {
      id: entryId || '',
    },
    {
      enabled: !!entryId,
    }
  );

  const productList = data?.relatedProducts?.productList as BlogProduct[];

  if (isLoading || !data) {
    return null;
  }

  return (
    <BlogRecommendationProducts
      title=""
      blogSlug={blogData?.blogPostCollection?.items[0]?.slug || ''}
      blogTitle={blogData?.blogPostCollection?.items[0]?.title || ''}
      blogProducts={productList || []}
    />
  );
}
